module.exports = __webpack_public_path__ + "img/ic_room_discount_left_img.520fcb6e.png";